<template>
  <div class="contactus flex-col">
    <!-- PC端内容 -->
    <div class="block_1 flex-col" v-if="!isMobile">
      <div class="p_img">
        <a href="javascript:;">
          <img src="../../../assets/contactUs/img/banner_11.jpg" alt="联系我们" title="联系我们">
        </a>
      </div>
      <div class="p_info">
        <div>
          <h2 class="text-white p_btitle">联系我们</h2>
          <h6 class="text-white p_subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</h6>
        </div>
      </div>
      <div class="box_2 flex-col">
        <div class="list_1 flex-row">
          <div
              class="text-wrapper_1 flex-col"
              v-for="(item, index) in loopData0"
              :key="index"
          >
              <span
                  v-if="item.slot1 === 1"
                  class="text_13"
                  :style="{ color: item.specialSlot1.lanhufontColor0 }"
                  v-html="item.specialSlot1.lanhutext0"
              ></span>
            <span v-if="item.slot2 === 2" class="text_14">证券事务</span>
            <span v-if="item.slot3 === 3" class="text_15">国际业务</span>
            <span
                class="text_16"
                :style="{ color: item.lanhufontColor0 }"
                v-html="item.lanhutext0"
            ></span>
          </div>
        </div>
        <div class="text-wrapper_2 flex-row justify-between">
          <span class="text_17">传真：0311-85323916</span>
          <span class="text_18">传真：0311-85323922</span>
        </div>
        <div class="section_3 flex-col">
          <div class="box_3 flex-col"></div>
          <div class="box_4 flex-col"></div>
          <div class="box_5 flex-col"></div>
        </div>
        <div class="section_4 flex-row">
            <div class="text-group_0 flex-col">
                <span class="text_19">供应商招募</span>
                <span class="text_20"><a target="_blank" href="https://tz.aepic.net:11122/portalweb">招采平台注册报名入口</a></span>
                <span class="text_20">电话：0311-85323908/10/19</span>
            </div>
            <div class="group_1 flex-col"></div>
            <div class="text-group_1 flex-col">
                <span class="text_19">投诉建议</span>
                <span class="text_20">电话：0311-85323985</span>
            </div>
            <div class="group_1 flex-col"></div>
            <div class="text-group_2 flex-col justify-between">
                <span class="text_22">邮箱</span>
                <span class="paragraph_1">corp&#64;sailhero.com.cn<br />sales&#64;sailhero.com.cn</span>
            </div>
            <div class="group_2 flex-col"></div>
            <div class="text-group_3 flex-col justify-between">
                <span class="text_23">官方微信众公号</span>
                <span class="text_24">sailhero</span>
            </div>
        </div>
      </div>
    </div>
    <div class="block_3 flex-col" v-if="!isMobile">
      <div class="box_6 flex-row">
        <div class="text-wrapper_3 flex-col justify-between">
          <span class="text_25">当前位置：首页&nbsp;&gt;&nbsp;联系我们</span>
          <span class="text_26">联系我们</span>
        </div>
        <div class="text-wrapper_6_be">
          <transition  name="slide">
            <div class="text-wrapper_4 flex-col" v-if="telshow">
              <span class="text_27">4001-300-137</span>
            </div>
          </transition>
        </div>
        <div class="box_8_1">
          <div class="group_3 flex-row" style="cursor:pointer" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
            <div class="image-text_1 flex-col justify-between">
              <img
                  class="label_1"
                  referrerpolicy="no-referrer"
                  :src="require('@/assets/humanResources/img/icon_lxfs.png')"
              />
              <span class="text-group_4">业务咨询</span>
            </div>
          </div>
        </div>
      </div>
      <div class="image-wrapper_1 flex-row">
        <img
            class="image_2"
            referrerpolicy="no-referrer"
            :src="require('@/assets/humanResources/img/dx_1.jpg')"
        />
      </div>
      <div class="box_7 flex-row justify-between">
        <div class="section_5 flex-col"></div>
        <div class="image-text_2 flex-row justify-between">
          <span class="text-group_5">先河环保售后办事处全国分布图</span>
          <div class="group_4 flex-col"></div>
        </div>
      </div>
      <div class="box_8 flex-row">
        <img class="group_5" :src="require('@/assets/contactUs/img/t_6.png')">
      </div>
      <div class="box_25 flex-row">
        <div class="grid_1 flex-row">
          <div
              class="list-items_1 flex-row alltime"
              v-for="(item, index) in afterSalesOfficeList"
              :key="index"
          >
            <span class="text_47" v-html="item.office_name" :title="item.office_name.replace(/<br\/>/g, '')"></span>
            <div class="group_41 flex-col"></div>
            <div class="text-wrapper_14 flex-col justify-between">
              <span class="text_48">联系人:</span>
              <span class="text_49">地址:</span>
            </div>
            <div class="group_42 flex-col justify-between">
              <div class="text-wrapper_15 flex-row">
                <span class="text_50" v-html="item.link_man"></span>
                <span class="text_51">联系电话:</span>
                <span class="text_52" v-html="item.link_phone"></span>
              </div>
              <span class="text_53" v-html="item.address" :title="item.address"></span>
            </div>
            <s></s>
          </div>
        </div>
      </div>
      <div class="box_27 flex-row justify-between">
        <div class="section_12 flex-col"></div>
        <div class="image-text_16 flex-row justify-between">
          <span class="text-group_19">网站留言</span>
          <div class="group_44 flex-col"></div>
        </div>
      </div>
      <div class="box_28 flex-row justify-between">
        <div class="text-wrapper_18">
          <span class="text_60">*</span> <span class="text_61">留言内容</span>
        </div>
        <div class="text-wrapper_19 flex-col">
          <el-input placeholder="请输入留言内容" type="textarea" :rows="5"  maxlength="500" show-word-limit="true" v-model:value="msg_content"></el-input>
        </div>
      </div>
      <div class="box_29 flex-row justify-between">
        <span class="text_63">姓名</span>
        <div class="text-wrapper_20 flex-col">
          <el-input placeholder="请输入姓名" type="text" maxlength="50" v-model:value="link_man"></el-input>
        </div>
      </div>
      <div class="box_30 flex-row justify-between">
        <span class="text_65">手机</span>
        <div class="text-wrapper_21 flex-col">
          <el-input placeholder="请输入手机号" type="text" maxlength="50" v-model:value="link_phone"></el-input>
        </div>
      </div>
      <div class="box_31 flex-row">
        <span class="text_67">验证码</span>
        <div class="text-wrapper_22 flex-col">
          <el-input placeholder="请输入验证码" type="text" maxlength="50" v-model:value="code"></el-input>
        </div>
        <!--验证码组件 不走后台纯前端实现-->
        <dentify class="image_17" :identifyCode="identifyCode"></dentify>
        <div class="image-text_17 flex-row justify-between" @click="refreshCode">
          <img
              class="thumbnail_3"
              referrerpolicy="no-referrer"
              :src="require('@/assets/contactUs/img/changeCode.png')"
          />
          <span class="text-group_20">换一换</span>
        </div>
      </div>
      <div class="box_32 flex-row" @click="submit">
        <div class="text-wrapper_23 flex-col">
          <span class="text_69">提交</span>
        </div>
      </div>
    </div>

    <!-- 移动端内容 -->
    <div class="mobile-contact-container" v-if="isMobile">
      <!-- Banner区域 -->
      <div class="mobile-contact-banner">
        <img class="mobile-contact-banner__image" src="../../../assets/contactUs/img/banner_11.jpg" alt="联系我们" />
        <div class="mobile-contact-banner__overlay"></div>
        <div class="mobile-contact-banner__content">
          <h1 class="mobile-contact-banner__title">联系我们</h1>
          <p class="mobile-contact-banner__subtitle">SAILHERO ENVIRONMENTAL PROTECTION</p>
        </div>
      </div>

      <!-- 面包屑导航 -->
      <div class="mobile-contact-breadcrumb">
        <p class="mobile-contact-breadcrumb__text">
          首页 > <span class="mobile-contact-breadcrumb__current">联系我们</span>
        </p>
      </div>

      <!-- 联系方式卡片区域 -->
      <div class="mobile-contact-info">
        <!-- 业务咨询 -->
        <div class="mobile-contact-card">
          <div class="mobile-contact-card__icon">
            <img src="../../../assets/humanResources/img/icon_lxfs.png" alt="业务咨询" />
          </div>
          <div class="mobile-contact-card__content">
            <h3 class="mobile-contact-card__title">业务咨询</h3>
            <a :href="'tel:4001300137'" class="mobile-contact-card__phone">电话：4001-300-137</a>
            <p class="mobile-contact-card__fax">传真：0311-85323916</p>
          </div>
        </div>

        <!-- 售后服务 -->
        <div class="mobile-contact-card">
          <div class="mobile-contact-card__icon">
            <img src="../../../assets/humanResources/img/icon_lxfs.png" alt="售后服务" />
          </div>
          <div class="mobile-contact-card__content">
            <h3 class="mobile-contact-card__title">售后服务</h3>
            <a :href="'tel:03118532392267590983'" class="mobile-contact-card__phone">电话：0311-85323922 / 67590983</a>
            <p class="mobile-contact-card__fax">传真：0311-85323922</p>
          </div>
        </div>

        <!-- 证券事务 -->
        <div class="mobile-contact-card">
          <div class="mobile-contact-card__icon">
            <img src="../../../assets/humanResources/img/icon_lxfs.png" alt="证券事务" />
          </div>
          <div class="mobile-contact-card__content">
            <h3 class="mobile-contact-card__title">证券事务</h3>
            <a :href="'tel:03118532390'" class="mobile-contact-card__phone">电话：0311-85323900</a>
          </div>
        </div>

        <!-- 国际业务 -->
        <div class="mobile-contact-card">
          <div class="mobile-contact-card__icon">
            <img src="../../../assets/humanResources/img/icon_lxfs.png" alt="国际业务" />
          </div>
          <div class="mobile-contact-card__content">
            <h3 class="mobile-contact-card__title">国际业务</h3>
            <a :href="'tel:+8631167300761'" class="mobile-contact-card__phone">电话：+86-311-67300761</a>
          </div>
        </div>

        <!-- 供应商招募 -->
        <div class="mobile-contact-card">
          <div class="mobile-contact-card__icon">
            <img src="../../../assets/humanResources/img/icon_lxfs.png" alt="供应商招募" />
          </div>
          <div class="mobile-contact-card__content">
              <h3 class="mobile-contact-card__title">供应商招募</h3>
              <a :href="'tel:0311-85323908/10/19'" class="mobile-contact-card__phone">电话：0311-85323908/10/19</a>
              <a href="https://tz.aepic.net:11122/portalweb" class="mobile-contact-other__text">招采平台注册报名入口</a>
          </div>
        </div>
      </div>

      <!-- 其他联系信息 -->
      <div class="mobile-contact-other">
        <!-- 投诉建议 -->
        <div class="mobile-contact-other__item">
          <div class="mobile-contact-other__icon">📞</div>
          <div class="mobile-contact-other__content">
            <h4 class="mobile-contact-other__title">投诉建议</h4>
            <a :href="'tel:03118532398'" class="mobile-contact-other__text">电话：0311-85323985</a>
          </div>
        </div>

        <!-- 邮箱 -->
        <div class="mobile-contact-other__item">
          <div class="mobile-contact-other__icon">📧</div>
          <div class="mobile-contact-other__content">
            <h4 class="mobile-contact-other__title">邮箱</h4>
            <a href="mailto:corp@sailhero.com.cn" class="mobile-contact-other__text">corp@sailhero.com.cn</a>
            <a href="mailto:sales@sailhero.com.cn" class="mobile-contact-other__text">sales@sailhero.com.cn</a>
          </div>
        </div>

        <!-- 微信公众号 -->
        <div class="mobile-contact-other__item">
          <div class="mobile-contact-other__icon">💬</div>
          <div class="mobile-contact-other__content">
            <h4 class="mobile-contact-other__title">官方微信公众号</h4>
            <p class="mobile-contact-other__text">sailhero</p>
          </div>
        </div>
      </div>

      <!-- 售后办事处标题 -->
      <div class="mobile-contact-section-title">
        <div class="mobile-contact-section-title__icon"></div>
        <h2 class="mobile-contact-section-title__text">先河环保售后办事处全国分布图</h2>
        <div class="mobile-contact-section-title__icon"></div>
      </div>

      <!-- 全国分布图 -->
      <div class="mobile-contact-map">
        <img class="mobile-contact-map__image" :src="require('@/assets/contactUs/img/t_6.png')" alt="全国分布图" />
      </div>

      <!-- 售后办事处列表 -->
      <div class="mobile-contact-offices">
        <div 
          class="mobile-contact-office-card"
          v-for="(item, index) in afterSalesOfficeList"
          :key="index"
        >
          <h3 class="mobile-contact-office-card__name" v-html="item.office_name.replace(/<br\/>/g, '')"></h3>
          <div class="mobile-contact-office-card__info">
            <div class="mobile-contact-office-card__row">
              <span class="mobile-contact-office-card__label">联系人：</span>
              <span class="mobile-contact-office-card__value" v-html="item.link_man"></span>
            </div>
            <div class="mobile-contact-office-card__row">
              <span class="mobile-contact-office-card__label">联系电话：</span>
              <a :href="'tel:' + item.link_phone.replace(/[^0-9]/g, '')" class="mobile-contact-office-card__phone" v-html="item.link_phone"></a>
            </div>
            <div class="mobile-contact-office-card__row mobile-contact-office-card__row--address">
              <span class="mobile-contact-office-card__label">地址：</span>
              <span class="mobile-contact-office-card__value" v-html="item.address" :title="item.address"></span>
            </div>
          </div>
        </div>
      </div>

      <!-- 网站留言标题 -->
      <div class="mobile-contact-section-title">
        <div class="mobile-contact-section-title__icon"></div>
        <h2 class="mobile-contact-section-title__text">网站留言</h2>
        <div class="mobile-contact-section-title__icon"></div>
      </div>

      <!-- 留言表单 -->
      <div class="mobile-contact-form">
        <!-- 留言内容 -->
        <div class="mobile-contact-form__group">
          <label class="mobile-contact-form__label">
            <span class="mobile-contact-form__required">*</span>留言内容
          </label>
          <el-input 
            placeholder="请输入留言内容" 
            type="textarea" 
            :rows="5"  
            maxlength="500" 
            show-word-limit 
            v-model="msg_content"
            class="mobile-contact-form__textarea"
          ></el-input>
        </div>

        <!-- 姓名 -->
        <div class="mobile-contact-form__group">
          <label class="mobile-contact-form__label">姓名</label>
          <el-input 
            placeholder="请输入姓名" 
            type="text" 
            maxlength="50" 
            v-model="link_man"
            class="mobile-contact-form__input"
          ></el-input>
        </div>

        <!-- 手机 -->
        <div class="mobile-contact-form__group">
          <label class="mobile-contact-form__label">手机</label>
          <el-input 
            placeholder="请输入手机号" 
            type="text" 
            maxlength="50" 
            v-model="link_phone"
            class="mobile-contact-form__input"
          ></el-input>
        </div>

        <!-- 验证码 -->
        <div class="mobile-contact-form__group mobile-contact-form__group--captcha">
          <label class="mobile-contact-form__label">验证码</label>
          <div class="mobile-contact-form__captcha-wrapper">
            <el-input 
              placeholder="请输入验证码" 
              type="text" 
              maxlength="50" 
              v-model="code"
              class="mobile-contact-form__input mobile-contact-form__input--captcha"
            ></el-input>
            <dentify 
              class="mobile-contact-form__captcha-image" 
              :identifyCode="identifyCode"
              :contentWidth="110"
              :contentHeight="44"
            ></dentify>
            <div class="mobile-contact-form__captcha-refresh" @click="refreshCode">
              <img src="../../../assets/contactUs/img/changeCode.png" alt="刷新" />
              <span>换一换</span>
            </div>
          </div>
        </div>

        <!-- 提交按钮 -->
        <div class="mobile-contact-form__submit">
          <button class="mobile-contact-form__button" @click="submit">提交</button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import dentify from "./components/dentify";
export default {
  components: {
    dentify,
  },
  data() {
    return {
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz", //随机串内容,从这里随机抽几个显示验证码
      identifyCode: "", //验证码图片内容
      link_man: "",
      link_phone: "",
      code: "",
      msg_content: "",
      afterSalesOfficeList:[],
      loopData0: [
        {
          lanhutext0: '电话：4001-300-137',
          lanhufontColor0: 'rgba(30,30,30,1)',
          specialSlot1: {
            lanhutext0: '业务咨询',
            lanhufontColor0: 'rgba(30,30,30,1)',
          },
          slot1: 1,
        },
        {
          lanhutext0: '电话：0311-85323922&nbsp;/&nbsp;67590983',
          lanhufontColor0: 'rgba(30,30,30,1)',
          specialSlot1: {
            lanhutext0: '售后服务',
            lanhufontColor0: 'rgba(30,30,30,1)',
          },
          slot1: 1,
        },
        {
          lanhutext0: '电话：0311-85323900',
          lanhufontColor0: 'rgba(30,30,30,1)',
          slot2: 2,
        },
        {
          lanhutext0: '电话：+86-311-67300761',
          lanhufontColor0: 'rgba(30,30,30,1)',
          slot3: 3,
        },
      ],
      constants: {},
      telshow:false,
      isMobile: false,
    };
  },
  methods: {
    submit() {
      var _this = this;
      console.log('是否验证通过:',this.identifyCode===this.code);
      if (this.code === '') {
        _this.$message.warning("请输入验证码");
        return;
      }
      if (this.identifyCode!==this.code) {
        _this.$message.warning("验证码错误");
        return;
      }
      if (this.msg_content === ''){
        _this.$message.warning("请输入留言内容");
        return;
      }
      var formData = {
        id: _this.$util.guid(),
        link_man: this.link_man,
        link_phone: this.link_phone,
        msg_content: this.msg_content,
      }
      _this.$api.post("/Client/commitMessage", formData,
          function (res) {
            if (res.code === "200" && res.msg === "true") {
              _this.$message.success("提交成功");
              _this.code = "";
              _this.refreshCode();
            } else {
              _this.$message.warning("提交失败");
            }
          },
          function (res) {
            _this.$message.error("服务异常，信息出错");
          }
      );


    },
    //获取办事处列表
    getData() {
      var _this = this;
      _this.$api.post(
          "/Client/getAfterSalesOffices",
          {pageSize:10000,pageIndex:1},
          function (res) {
            if (res.code == "200") {
              _this.total = res.count;
              res.data.forEach(item => {
                var office_name = item.office_name;//这里只支持公司总部和XXX办事处的样式调整 并且XXX办事处，办事处前最多3个字，否则可能会造成样式错乱
                var contentToAdd = '<br/>';
                if (office_name === '公司总部'){
                  var targetStr = '总部';
                  item.office_name = office_name.replace(targetStr, contentToAdd + targetStr);
                }else {
                  var targetStr = '办事处';
                  item.office_name = office_name.replace(targetStr, contentToAdd + targetStr);
                }

              });
              _this.afterSalesOfficeList = res.data;
            }
          }
      );
    },
    // 重置验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //获取验证码的值
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        //通过循环获取字符串内随机几位
        this.identifyCode +=
            this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    //随机数字：用于当角标拿字符串的值
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    handleMouseEnter(){
        let that = this;
        that.telshow = true;
        },
    handleMouseLeave(){
        let that = this;
        that.telshow = false;
    },
    // 检测是否为移动端
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    // 处理窗口大小变化
    handleResize() {
      this.checkMobile();
    }
  },
  mounted() {
    let that = this;
    that.getData();
    // 检测移动端
    this.checkMobile();
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  created() {// 初始化验证码
    this.identifyCode = "";
    //参数：1.随机串内容。2.验证码显示位数
    this.makeCode(this.identifyCodes, 4);},
};
</script>
<style src="../../../assets/contactUs/css/index.css"/>
<style src="../../../assets/contactUs/css/mobile.css"/>
<style scoped>

.p_img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  animation: bannerimg 2s;
}

.p_info .p_btitle {
  animation: puBanner 1s;
  color: #FFF;
  font-size: 59px;
  font-weight: 900;
  letter-spacing: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.p_info .p_subtitle {
  animation: puBanner 1s;
  color: #FFF;
  font-size: 28px;
  font-weight: 400;
  position: relative;
  bottom: 40px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.p_info {
  width: 100%;
  max-width: 1600px;
  padding: 0 5px;
  position: absolute;
  left: 257px;
  top: 120px;
  z-index: 9;
}

@keyframes puBanner {
  from {
    transform: translateY(200px);
    opacity: 0
  }

  to {
    transform: translateY(0);
    opacity: 1
  }
}

@keyframes bannerimg {
  from {
    transform: scale(1.2)
  }

  to {
    transform: scale(1);
  }
}
</style>
